<template>
    <div>
        <monitoring-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.ADMIN"></monitoring-admin>
        <monitoring-regional-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.REGIONAL_ADMIN"></monitoring-regional-admin>
        <monitoring-applicant v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.APPLICANT"></monitoring-applicant>
        <monitoring-auditor v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.AUDITOR"></monitoring-auditor>
    </div>
</template>
<script>
    import {UserRoles} from '@/services';
    import MonitoringAdmin from './MonitoringAdmin';
    import MonitoringRegionalAdmin from './MonitoringRegionalAdmin';
    import MonitoringApplicant from './MonitoringApplicant';
    import MonitoringAuditor from './MonitoringAuditor';

    export default
    {
        components:
        {
            MonitoringAdmin,
            MonitoringRegionalAdmin,
            MonitoringApplicant,
            MonitoringAuditor
        },
        data()
        {
            return {
                loggedUser: {},
                UserRoles
            }
        },
        beforeMount()
        {
            this.loggedUser = this.$store.getters['Auth/loggedUser'];
        },
    };
</script>
